import { DuplicateId } from "@mcleod/dispatch";
import { AutogenLayoutObjection } from "./autogen/AutogenLayoutObjection";
import { DataSourceExecutionEvent } from "@mcleod/components";

export class Objection extends AutogenLayoutObjection {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "objection",
            screenName: "Objection",
            navigateToUrl: "lme/crm/Objection?mode=update&key=",
            compositeKeyValues: {
                "type_of": "C"
            }
        });
    }

    sourceObjectionBeforeExecution(event: DataSourceExecutionEvent): void | Promise<void> {
        if (this.activeRow?.isNull("type_of")) {
            this.activeRow.set("type_of", "C");
        }
    }
}